import styled from '@emotion/styled'
import tokens from '@lacedltd/design-tokens'
import { keyframes } from '@emotion/react'
import { mediaQuery, Typography } from '@lacedltd/laced-components'

const fadeInFromNone = keyframes`
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
`

export const ExpressCheckoutWrapper = styled.div({
  animation: `${fadeInFromNone} 0.5s ease-in`
})

export const Separator = styled.div({
  position: 'relative',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '30px',
  marginBottom: tokens.spacing[5],

  [mediaQuery.m.min]: {
    padding: `0 ${tokens.spacing[8]}`
  }
})

export const SeparatorText = styled(Typography.Text)({
  position: 'absolute',
  margin: '0 auto',
  fontSize: tokens.fontSize[2],
  color: tokens.color.airJordan[600],
  letterSpacing: '0.2em',
  backgroundColor: tokens.color.superstar[100],
  padding: `0 ${tokens.spacing[3]}`
})

export const HorizontalLine = styled.div({
  width: '100%',
  height: '1px',
  border: 0,
  background: tokens.color.airJordan[400],

  [mediaQuery.m.min]: {
    width: '100%'
  }
})
